import { ImageWithLoaderComponent } from './../../../../../building-blocks/components/image-with-loader/image-with-loader.component';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  QueryList,
  ViewChildren,
  computed,
  inject,
  input,
} from '@angular/core';

import { CMSFileDetail, MediaToolkitAssetsShow } from 'www-cms';
import { ButtonComponent } from 'ui-elements/button';
import { FileSizePipe } from 'api';
import { WWW_CONFIG, WWWConfig } from '../../../../models/config.model';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-media-toolkit-asset-list',
  imports: [
    ButtonComponent,
    ImageWithLoaderComponent,
    FileSizePipe,
    DirectusDirective,
  ],
  templateUrl: './media-toolkit-asset-list.component.html',
  host: {
    '[id]': 'assetListId()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaToolkitAssetListComponent {
  private wwwConfig = inject<WWWConfig>(WWW_CONFIG);

  @ViewChildren('.download-link-button')
  downloadButtons?: QueryList<ElementRef>;
  assetsBaseUrl = this.wwwConfig.baseAssetUrl;
  assetListContent = input.required<MediaToolkitAssetsShow>();
  defaultThumbnail = input<CMSFileDetail>();
  collectionName = input<string>('mediaToolkitAssetsShow');
  categoryCollectionName = computed(() =>
    this.collectionName().replace('AssetsShow', 'AssetShowCategory')
  );

  assetListId = computed(() => this.assetListContent().id);

  downloadAllClicked() {
    const buttons = document.getElementsByClassName('download-link-button');
    for (let i = 0; i < buttons.length; i++) {
      (buttons[i] as HTMLElement).click();
    }
  }
}
